import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';
export default () => {
  const { breakpoints, colors, fluidTypeScale } = useTheme();
  return {
    cards: css`
    margin-right:20px;
      ${breakpoints.l} {
      :nth-of-type(2) {
      margin-top: 3.5rem;
      }
      `,
    innerWrapper: css`
      padding-bottom: 2rem;
    `,
    card: css`
      margin-top: -1px;
      border-radius: 8px;
      border: 1px solid ${colors.lightGrey};
      grid-auto-rows: 8.3rem;
    `,
    header: css`
      text-transform: uppercase;
      color: ${colors.red};
      font-size: ${fluidTypeScale.font12_12};
      line-height: 16px;
      margin-bottom: 10px;
      cursor: pointer;
      letter-spacing: 0.12em;

      ${breakpoints.l} {
        text-align: left;
        font-size: ${fluidTypeScale.font12_12};
        line-height: 16px;
        margin-bottom: 10px;
        font-weight: 700;
      }
    `,
    description: (isExpanded)=>css`
      color: ${colors.navy};
      font-size: ${fluidTypeScale.font18_18};
      line-height: 24px;
      letter-spacing: 0.0027em;
      height: 120px;
      cursor: pointer;
      ${isExpanded === true &&
        css`
          height: auto;
        `}

      ${breakpoints.l} {
        font-size: ${fluidTypeScale.font18_18};
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0.0027em;
        text-align: left;
      }
    `,
    infoSection: css`
      ${breakpoints.l} {
        min-width: 15.625rem;
      }
    `,
    learnMore: css`
      display: flex;
      align-items: center;
      Padding: 15px 0px 8px 0px;
      border-top: 1px solid ${colors.lightGrey};
      margin-top: 2rem;
      margin-bottom: 1rem;

      ${breakpoints.l} {
      display: flex;
      `,
      link: css`
      color: ${colors.navy};
      text-decoration: none;
      &:hover, &:active {
        text-decoration: underline;
        text-decoration-color: ${colors.navy};
      }
      &:focus-visible {
        padding: 0px 0px;
        background-color: ${colors.skip_yellow};
        outline: none;
        border-bottom: 2px solid ${colors.border_black};
        &:hover{
          text-decoration: underline;
          text-decoration-color: ${colors.black};
        }
        p{ 
          margin-bottom: 0;
        }
        p span {
          color: ${colors.black};
        }
        p img {
          filter: grayscale(1) brightness(0) invert(0);
        }
      }
    `,
    imgSection: ({ desktop, mobile }) => css`
      width: 100%;
      height: 195px;
      border-radius: 8px 8px 0px 0px;
      background: url(${mobile.src}) 0 0 no-repeat;
      background-size: cover;
      position: relative;
      cursor: pointer;
      margin-left: 1px !important;
      &:focus-visible {
        outline: none;
        .youtube {
          border: 2px solid  ${colors.border_black};
          outline: 2px solid ${colors.skip_yellow};
        }
      }

      ${breakpoints.l} {
        background: url(${desktop.src}) 0 0 no-repeat;
        background-size: cover;
      }

      .youtube {
        cursor: pointer;
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 2;
        &:hover{
          filter: brightness(77%);
        }
        &:active{
          filter: brightness(77%);
        }
      }
    `,
    cardalign:(isExpanded)=> css`
      background-color: ${colors.white};
      padding: 32px 24px 15px 24px;
      height: 270px;
      ${isExpanded === true &&
        css`
          height: auto;
        `}
    `,
    learnmore: css`
      font-size: ${fluidTypeScale.font15_15};
      letter-spacing: 0.12em;
      text-align: left;
      line-height: 16px;
      color: ${colors.navy};
      text-transform: uppercase;
      font-weight: 700;
    `,
    learnmoreArrow: css`
      margin-left: auto;
    `,
    quickLinkContainer: css`
      display: inline-flex;
      height: 100%;
      background-color: ${colors.white};
      padding-top: 5px;
    `,
    showMore: css`
    color: ${colors.next_grey};
    cursor: pointer;
    font-weight: 700;
    text-decoration: none;
    display: inline-block;
    &:hover {
        text-decoration: underline;
        text-decoration-color: ${colors.next_grey};
        cursor: pointer;
      }
      &:active {
        text-decoration: underline;
        text-decoration-color: ${colors.next_grey};
      }
    ${breakpoints.l}{
      &:hover{
        text-decoration: underline;
      }
    }
    &:focus-visible {
        background-color: ${colors.skip_yellow};
        outline: none;
        color: ${colors.border_black};
        border-bottom: 2px solid ${colors.border_black};
        span img {
         filter: grayscale(1) brightness(0) invert(0);
        }
      }
  `,
  expandArrow: css`
    display: inline-block;
    margin-left: 3px;
    vertical-align: middle;
  `,

  };
};

//below styles are added for lightbox video player and imported in components that contains video

export const videoOverlay = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(29, 29, 27, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 200;
  cursor: default;
}
`;

export const videoContainer = css`
  width: 640px;
  height: 360px;
  position: relative;

  @media screen and (max-device-width: 768px) {
    width: 100%;
    height: 56.25vw;
  }

  @media (min-device-width: 769px) and (max-device-width: 992px) {
    width: 576px;
    height: 324px;
  }

  @media (min-device-width: 992px) and (max-device-width: 1196px) {
    min-width: 576px;
    width: 50vw;
    height: 28.15vw;
  }
`;

export const videoWrapper = css`
  width: 100%;
  height: 100%;
`;

export const closeButton = css`
  position: absolute;
  left: 37.5rem;
  top: -3rem;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  background: none;
  color: white;
  cursor: pointer;
  display: inline-block;
  transition: filter ease;

  &:hover, &:focus {
    filter: brightness(0) saturate(100%) invert(75%) sepia(50%) saturate(300%) hue-rotate(190deg);
  }

  @media screen and (max-device-width: 375px) {
    left: 90%;
  }

  @media (min-device-width: 375px) and (max-device-width: 750px) {
    left: 90%;
  }

  @media (min-device-width: 750px) and (max-device-width: 768px) {
    left: 45.5rem;
  }

  @media (min-device-width: 769px) and (max-device-width: 992px) {
    left: 33.5rem;
  }

  @media (min-device-width: 992px) and (max-device-width: 1196px) {
    left: 33.5rem;
  }
`;
